module.exports = __webpack_public_path__ + "static/media/BoxPlotQ2_2.deb4a296.svg";